import instance from "./base";

export const contactUs = (data) =>{
    const url = "/smartsafe/contact-us";
    const response = instance.post(url,data)
    return response;
}